// @flow

import memoize from 'memoize-weak';
import { isEmpty } from 'lodash';

import { getRootNodeOfPath } from 'app/beta-editor/utils/PathUtils';
import { getSteps } from 'app/beta-editor/utils/FlowUtils';

import type { Flow, NodeMap } from 'app/beta-editor/flowState';
import type { ID } from 'app/common/types';

const createFlowWithSteps = memoize((flow, steps): Flow => {
  return {
    ...flow,
    steps,
  };
});

const EMPTY_STEPS = [];

const getFlowWithSteps = (
  flow: Flow,
  flowId: ID,
  nodes: NodeMap,
  nodeId: ID
): ?Flow => {
  if (isEmpty(flow)) {
    // still loading
    return undefined;
  }

  if (isEmpty(nodes)) {
    // still loading nodes
    return {
      ...flow,
      steps: EMPTY_STEPS,
    };
  }

  const rootNodeOfPath = getRootNodeOfPath(flowId, flow.nodes, nodeId);
  const steps = rootNodeOfPath
    ? getSteps(flowId, flow.nodes, rootNodeOfPath.id)
    : EMPTY_STEPS;

  return createFlowWithSteps(flow, steps);
};

export default getFlowWithSteps;
